import type { LoginResponse, LogoutResponse } from "@/types/auth.ts";
import { userApiClient } from "@/lib/api-client.ts";

const AUTH_BASE_URL = "/v1/auth";

export const authApi = {
  // 로그인
  login: async (
    credentials: { loginId: string; password: string }, // 로그인 정보
    deviceId: string // 디바이스 ID
  ): Promise<LoginResponse> => {
    const response = await userApiClient.post<LoginResponse>(
        `${AUTH_BASE_URL}/login`,
        {
          loginType: 'EMAIL',
          ...credentials,
        },
        {
          headers: {
            'X-Device-ID': deviceId
          },
        }
      )
    return response.data
  },

  // 로그아웃
  logout: async ():Promise<LogoutResponse> => {
    const response = await userApiClient.post<LogoutResponse>(`${AUTH_BASE_URL}/logout`)
    return response.data
  }
}